(function(){
  if (window.__ostGal) return;
  window.__ostGal = true;

  /* The gallery used to swap by writing the full-size PNG straight into src.
     That meant a cold 400-600KB download on every click, with no visual
     feedback while it landed. Fixes: ask the CDN for a transform (so it serves
     WebP), warm every image on idle so later clicks are cache hits, and only
     swap once the next frame has actually decoded. Arrows and swipe on top. */

  var CDN_W = 1024;
  var SWIPE = 42;

  function light(url){
    if (!url) return url;
    return url.replace(/([?&]width=)\d+/, '$1' + CDN_W);
  }

  function chevron(dir){
    var d = dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d +
      '" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function boot(){
    var wrap = document.querySelector('.ost-gal__main');
    var thumbs = [].slice.call(document.querySelectorAll('[data-ost-thumb]'));
    if (!wrap || !thumbs.length) return;
    var img = wrap.querySelector('img');
    if (!img || wrap.__ostGalBound) return;
    wrap.__ostGalBound = true;

    var index = Math.max(0, thumbs.findIndex(function(b){
      return b.getAttribute('aria-current') === 'true';
    }));

    function warm(){
      thumbs.forEach(function(b){
        var i = new Image();
        i.decoding = 'async';
        i.src = light(b.getAttribute('data-ost-thumb'));
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 });
    else setTimeout(warm, 1200);

    var token = 0;

    function show(n){
      if (n < 0) n = thumbs.length - 1;
      if (n >= thumbs.length) n = 0;
      var btn = thumbs[n];
      if (!btn) return;
      index = n;
      thumbs.forEach(function(b){ b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      if (btn.scrollIntoView) btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });

      var url = light(btn.getAttribute('data-ost-thumb'));
      if (!url) return;
      if (img.currentSrc === url || img.getAttribute('src') === url) return;

      var mine = ++token;
      wrap.classList.add('is-swapping');
      // Only show a spinner if the image is genuinely slow; a cache hit
      // should never flash one.
      var slow = setTimeout(function(){
        if (mine === token) wrap.classList.add('is-waiting');
      }, 140);

      var next = new Image();
      next.decoding = 'async';

      function done(){
        clearTimeout(slow);
        if (mine !== token) return;
        img.removeAttribute('srcset');
        img.src = url;
        var a = btn.getAttribute('data-ost-alt');
        if (a) img.alt = a;
        wrap.classList.remove('is-waiting');
        requestAnimationFrame(function(){ wrap.classList.remove('is-swapping'); });
      }

      next.onerror = done;
      next.src = url;
      if (next.decode) next.decode().then(done).catch(done);
      else if (next.complete) done();
      else next.onload = done;
    }

    /* arrows */
    if (thumbs.length > 1) {
      ['prev','next'].forEach(function(dir){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ost-gal__nav ost-gal__nav--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = chevron(dir);
        b.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          show(dir === 'prev' ? index - 1 : index + 1);
        });
        wrap.appendChild(b);
      });
      wrap.classList.add('has-nav');
    }

    /* swipe */
    var x0 = null, y0 = null;
    wrap.addEventListener('touchstart', function(e){
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY;
    }, { passive: true });
    wrap.addEventListener('touchend', function(e){
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      // Ignore mostly-vertical drags so page scrolling still works.
      if (Math.abs(dx) < SWIPE || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      show(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });

    // Capture phase, so the section's own inline click handler — which does the
    // slow synchronous swap — never gets the event.
    document.addEventListener('click', function(e){
      var btn = e.target && e.target.closest ? e.target.closest('[data-ost-thumb]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      show(thumbs.indexOf(btn));
    }, true);

    document.addEventListener('keydown', function(e){
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var active = document.activeElement;
      if (!active || !active.closest) return;
      if (!active.closest('.ost-gal__thumbs') && !active.closest('.ost-gal__main')) return;
      e.preventDefault();
      show(e.key === 'ArrowRight' ? index + 1 : index - 1);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
